import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { CisProSearchComponent } from '../../cispro-search/cispro-search.component';
import { CisProSearchResult } from '../../../services/cispro-search.service';

export interface SpacerCisproContainersDialogData {
  containers: string[];
}

@Component({
  selector: 'app-spacer-cispro-containers-dialog',
  standalone: true,
  imports: [CommonModule, FormsModule, MatDialogModule, MatIconModule],
  templateUrl: './spacer-cispro-containers-dialog.component.html',
  styleUrls: ['./spacer-cispro-containers-dialog.component.css']
})
export class SpacerCisproContainersDialogComponent {

  rows: { value: string }[] = [];

  constructor(
    private dialogRef: MatDialogRef<SpacerCisproContainersDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: SpacerCisproContainersDialogData,
    private dialog: MatDialog
  ) {
    this.rows = (data.containers ?? []).map(c => ({ value: c }));
  }

  addRow(): void {
    this.rows.push({ value: '' });
  }

  removeRow(index: number): void {
    this.rows.splice(index, 1);
  }

  clearRow(index: number): void {
    this.rows[index].value = '';
  }

  searchRow(index: number): void {
    const ref = this.dialog.open(CisProSearchComponent, {
      width: '90%',
      maxWidth: '1300px',
      maxHeight: '85vh',
      panelClass: 'cispro-search-dialog'
    });

    ref.afterClosed().subscribe((result: CisProSearchResult | undefined) => {
      if (result) {
        this.rows[index].value = result.barcodeId;
      }
    });
  }

  close(): void {
    const updated = this.rows
      .map(r => r.value.trim())
      .filter(v => v.length > 0);
    this.dialogRef.close(updated);
  }
}
